


// mudar para desenvolvimento
// const PROJECT = "452729552991";

// mudar para produção
const PROJECT = "712108985873";

const REGION = "southamerica-east1";


const BASE = {
    firebase: `https://services-firebase-${PROJECT}.${REGION}.run.app`,
    email: `https://services-email-${PROJECT}.${REGION}.run.app`,
    gptmaker: `https://services-gptmaker-${PROJECT}.${REGION}.run.app`,
    asaas: `https://services-asaas-${PROJECT}.${REGION}.run.app`,
    report: `https://services-report-${PROJECT}.${REGION}.run.app`,
    agenda: `https://services-agenda-${PROJECT}.${REGION}.run.app`,
    agenda_medical: `https://services-agenda-medical-${PROJECT}.${REGION}.run.app`,
    agenda_dentist: `https://services-agenda-dentist-${PROJECT}.${REGION}.run.app`,
};



export const ENDPOINTS = {

    firebase: {
        updatePassword: `${BASE.firebase}/update-password`,
        updateEmail: `${BASE.firebase}/update-email`,
        checkEmail: `${BASE.firebase}/check-email`,
        registerLog: `${BASE.firebase}/register-log`,
    },

    email: {
        validToken: `${BASE.email}/email/valid-token`,
        expiredTests: `${BASE.email}/email/expired-tests`,
        welcomeTests: `${BASE.email}/email/welcome-tests`,
    },

    gptmaker: {
        emptyTraining: `${BASE.gptmaker}/treinamento/empty`,
        addTraining: `${BASE.gptmaker}/treinamento/add`,
        addIntention: `${BASE.gptmaker}/intencao/add`,
        agentUpdate: `${BASE.gptmaker}/agent/update`,
        dashs1: `${BASE.gptmaker}/dashs1`,
        agentCredits: `${BASE.gptmaker}/agent/credits`,
        updateName: `${BASE.gptmaker}/agent/updatename`,
        agentEmpty: `${BASE.gptmaker}/agent/empty`,
        agentActive: `${BASE.gptmaker}/agent/active`,
    },

    agenda: {
        
        findfreeSchedule: `${BASE.agenda}/calendar/findfree`,
        findSchedule: `${BASE.agenda}/calendar/findschedule`,
        finddaySchedule: `${BASE.agenda}/calendar/findday`,
        addSchedule: `${BASE.agenda}/calendar/add`,
        cancelSchedule: `${BASE.agenda}/calendar/cancel`,
        humancontactSchedule: `${BASE.agenda}/calendar/human_contact`,

        // agenda medicos
        medical_addIntentions: `${BASE.agenda_medical}/calendar/add_intentions`,

        // agenda dentistas
        dentist_addIntentions: `${BASE.agenda_dentist}/calendar/add_intentions`,

    },

    asaas: {
        addClient: `${BASE.asaas}/upsertclient`,
        createSubscription: `${BASE.asaas}/createsubscription`,
        paymentInfo: `${BASE.asaas}/paymentinfo`,
        cancelSubscription: `${BASE.asaas}/cancellsubscription`,
        paymentCard: `${BASE.asaas}/paymentcard`,
    },

    report: {
        sales_pages: `${BASE.report}/analytics/sales_pages`,
        sales_events: `${BASE.report}/analytics/sales_events`,
        sales_url_parameters: `${BASE.report}/analytics/sales_url_parameters`,
        clients: `${BASE.report}/firestore/clients`,
    }

};

